"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MeetingWorkspaceParticipationHistorySchema", {
    enumerable: true,
    get: function() {
        return MeetingWorkspaceParticipationHistorySchema;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _base = require("../base");
const MeetingWorkspaceParticipationHistorySchema = _base.BaseDocument.extend({
    /** Foreign key - meeting_workspaces document */ meeting_workspace_id: _zod.z.instanceof(_bson.ObjectId),
    /** Foreign key - user document */ user_id: _zod.z.instanceof(_bson.ObjectId),
    /** Timestamp when the participant joined (or was added to) the workspace */ joined_at: _zod.z.instanceof(Date),
    /** Timestamp when the participant left (or was removed from) the workspace. Null if currently active. */ left_at: _zod.z.instanceof(Date).nullable()
});
